export enum EUserUrls {
  PROFILE = 'profile',
  IMPERSONATION = 'impersonation',
}
